import { render, staticRenderFns } from "./certificate-category-table.vue?vue&type=template&id=31e8a24a&scoped=true&"
import script from "./certificate-category-table.ts?vue&type=script&lang=ts&"
export * from "./certificate-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./certificate-category-table.scss?vue&type=style&index=0&id=31e8a24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e8a24a",
  null
  
)

export default component.exports